import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { DatePicker } from "@mui/x-date-pickers";
import {
  Button,
  CircularProgress,
  Paper,
  Grid,
  FormControl,
  Alert,
} from "@mui/material";

import { CheckboxList } from "../components/CheckboxList";
import {
  putAssigments,
  setOk,
  setError,
} from "../../../actions/reports-assignment";

import "./index.css";
import dayjs from "dayjs";

export default function AsignReports(props) {
  const { title } = props;

  const physicians = useSelector((store) => store.physicians);
  const error = useSelector((store) => store.error);
  const ok = useSelector((store) => store.ok);
  const loading = useSelector((store) => store.loading);
  const dispatch = useDispatch();

  const today = dayjs();
  const tomorrow = dayjs().add(1, "day");

  const [start, setStart] = useState(today);
  const [end, setEnd] = useState(tomorrow);
  const [selected, setSelected] = useState([]);
  const [warning, setWarning] = useState(false);

  useEffect(() => {
    setSelected(
      physicians.map((i) => ({
        name: i.name,
        id: i.userId,
        selected: false,
      }))
    );
  }, [physicians]);

  useEffect(() => {
    return () => {
      dispatch(setOk(""));
      dispatch(setError(""));
    };
  }, [dispatch]);

  const handleCheck = (e) => {
    const id = e.target.id;
    setSelected((state) =>
      state.map((p) => (p.id === id ? { ...p, selected: !p.selected } : p))
    );
  };

  const handleSubmit = () => {
    const interval = {
      startTime: start.toDate().getTime(),
      endTime: end.toDate().getTime(),
      users: selected
        .filter((i) => i.selected)
        .map(({ id, name }) => ({ id, name })),
    };

    if (interval.users.length) {
      setWarning(false);
      // Only reset users; retain current dates
      setSelected(
        physicians.map((i) => ({
          name: i.name,
          id: i.userId,
          selected: false,
        }))
      );
      dispatch(putAssigments(interval));
    } else {
      setWarning(true);
    }
  };

  return (
    <Paper
      elevation={0}
      style={{ padding: "0px 15px 15px", marginBottom: "15px" }}
      className="assign-reports"
    >
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <span style={{ fontWeight: "bold" }}>{title}</span>
          </Grid>
        </Grid>
        <h3
          style={{ margin: "10px 0 0", padding: "10px 0 0", marginBottom: 0 }}
        >
          Intervals
        </h3>
        <div className="cals">
          <FormControl fullWidth>
            <DatePicker
              disablePast
              showTodayButton
              className="cal"
              label="Start Date"
              value={start}
              onChange={(date) => {
                if (date && dayjs(date).isValid()) setStart(date);
              }}
            />
          </FormControl>
          <FormControl fullWidth>
            <DatePicker
              disablePast
              showTodayButton
              className="cal"
              label="End Date"
              value={end}
              onChange={(date) => {
                if (date && dayjs(date).isValid()) setEnd(date);
              }}
            />
          </FormControl>
        </div>

        <CheckboxList onChange={handleCheck} items={selected} />
        {!loading && (
          <Button onClick={handleSubmit} variant="contained" color="secondary">
            Submit
          </Button>
        )}
      </div>
      {loading && (
        <div
          style={{
            width: "500px",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
      {warning && (
        <div style={{ width: "500px", margin: "auto", marginTop: "20px" }}>
          <Alert severity="warning">Please select one of the physicians</Alert>
        </div>
      )}
      {error && (
        <div style={{ width: "500px", margin: "auto", marginTop: "20px" }}>
          <Alert severity="error">{error}</Alert>
        </div>
      )}
      {ok && (
        <div style={{ width: "500px", margin: "auto", marginTop: "20px" }}>
          <Alert severity="success">{ok}</Alert>
        </div>
      )}
    </Paper>
  );
}
